export default {
    fields: [
        {
            key: "id",
            label: "#",
            sorter: false,
            filter: false,
            _style: "width:5%",
            _filter: false,
        },
        {
            key: "title",
            label: "title",
            sorter: false,
            filter: false,
            _style: "width:20%",
            _filter: true,
        },
        {
            key: "type",
            label: "type",
            sorter: false,
            filter: false,
            _style: "width:10%",
            _filter: true,
        },
        {
            key: "message",
            label: "message",
            sorter: false,
            filter: false,
            _style: "width:20%",
            _filter: true,
        },
        {
            key: "created_at",
            label: "created_at",
            sorter: false,
            filter: false,
            _style: "width:10%",
            _filter: false,
        }
    ],
    allFields: [],
    items: [],
    order: "desc",
    rows: 5,
    page: 1,
    total_pages: 0,
    loading: true,
    url: "/notification.api/list",
    columnFilterValue: {},
    itemsPerPageSelect: true,
    itemSelected: null
}